import { ApprovalStatus, ApprovalActorRole, ApprovalStepStatus, ApprovalOperation, ApprovalTypes } from 'ui-product-approvals-common';
import { canRejectApproval } from './canRejectApproval';
import { canRequestChanges } from './canRequestChanges';
export const getAvailableOperations = ({
  configEnabled,
  isLoading,
  approvalStatus,
  approvalConcluded,
  hasApprovalData,
  currentActorRole,
  stepStatusForCurrentActor,
  hasApproveScope,
  hasChangesRequestedGate,
  approvalType,
  restartOnConclude
}) => {
  if (!configEnabled || isLoading) {
    return [];
  }
  switch (approvalStatus) {
    case ApprovalStatus.APPROVAL_PENDING:
      if (currentActorRole === ApprovalActorRole.APPROVER && stepStatusForCurrentActor === ApprovalStepStatus.APPROVAL_PENDING) {
        return [ApprovalOperation.APPROVE, ...(canRejectApproval({
          approvalType
        }) ? [ApprovalOperation.REJECT] : []), ...(hasChangesRequestedGate && canRequestChanges({
          approvalType
        }) ? [ApprovalOperation.REQUEST_CHANGES] : []), ...(hasApproveScope ? [ApprovalOperation.CANCEL] : [])];
      } else if (currentActorRole === ApprovalActorRole.REQUESTER) {
        return [ApprovalOperation.CANCEL];
      } else if (hasApproveScope) {
        return [ApprovalOperation.CANCEL];
      }
      return [];
    case ApprovalStatus.CHANGES_REQUESTED:
      if (currentActorRole === ApprovalActorRole.APPROVER && (stepStatusForCurrentActor === ApprovalStepStatus.APPROVAL_PENDING || stepStatusForCurrentActor === ApprovalStepStatus.CHANGES_REQUESTED)) {
        return [ApprovalOperation.APPROVE, ...(canRejectApproval({
          approvalType
        }) ? [ApprovalOperation.REJECT] : []), ...(hasChangesRequestedGate && canRequestChanges({
          approvalType
        }) ? [ApprovalOperation.REQUEST_CHANGES] : []), ...(hasApproveScope ? [ApprovalOperation.CANCEL] : [])];
      } else if (currentActorRole === ApprovalActorRole.REQUESTER) {
        return [ApprovalOperation.CANCEL];
      } else if (hasApproveScope) {
        return [ApprovalOperation.CANCEL];
      }
      return [];

    // Approval not started - treat the same as CANCELLED.
    case undefined:
    case ApprovalStatus.CANCELLED:
      if (approvalType !== ApprovalTypes.QUOTE) {
        return [ApprovalOperation.REQUEST];
      }
      return [];
    case ApprovalStatus.APPROVED:
      if (restartOnConclude && hasApprovalData && approvalConcluded && approvalType !== ApprovalTypes.QUOTE) {
        return [ApprovalOperation.REQUEST];
      }
      return [];
    case ApprovalStatus.REJECTED:
      if (approvalType === ApprovalTypes.CONNECTED_APP) {
        return [ApprovalOperation.REQUEST];
      }
      return [];
    default:
      return [];
  }
};